export default {
 "+/R6RX": "任务状态",
 "+0SHNk": "Wi-Fi MAC Address",
 "+4lD9e": "姓名",
 "+74JfZ": "示例：Device_000001_高桥店_Android",
 "+7V2pl": "共",
 "+CLSks": "2. 此命名规则要套用的设备系统类型",
 "+GQdfc": "更新Token",
 "+L9lak": "套用报警模板",
 "+TzicH": "门店",
 "+d1f6p": "上传Linux设备",
 "+gbx50": "报警条件",
 "+kHAfa": "请填写门店详情",
 "+m8vFq": "命名规则详情",
 "+uAolt": "例：允许用户轻松自定义网站标题、图标和文本，以获得个性化的网络体验",
 "+wet4N": "验证码错误",
 "/8GfsH": "四",
 "/99v4N": "全部门店",
 "/CxA3j": "添加子门店",
 "/Qlgz9": "上传Windows设备",
 "/SqqyP": "输入设备序列号",
 "/cqdKk": "下载",
 "/sI6h+": "人",
 "03eM6t": "200条/页",
 "0Drg5o": "我同意上述条款",
 "0KH9Qi": "设备系统类型",
 "0UAhKu": "例：https://nubiscloud.freshdesk.com/support/home",
 "0VK6Tv": "营业状态",
 "0YYUNG": "已选择{num}个标签",
 "0h3ZUE": "账号中心上传",
 "0iTEVO": "查看Token",
 "0lEh3g": "Nubis 空间上传",
 "0uRy1k": "一",
 "0xMj0V": "例：提供进版或是更新设备的image",
 "11uVJ/": "接收对象",
 "19+woq": "门店详情",
 "1M03Dq": "排程模板",
 "1PtjRr": "设备名称",
 "1SslIM": "关闭应用",
 "1X8SYs": "经纬度",
 "1sAivX": "Ethernet MAC Address",
 "1sj5Sj": "移除所有本设备套用的排程模版",
 "1yM7WW": "是否将选择的设备移除？",
 "2/LdaO": "门店配置信息",
 "2IaM+V": "更新中心",
 "2JW1Pt": "请选择是否同时发送邮件",
 "2MYr1m": "登录",
 "2QzYmY": "取消",
 "2nV3tA": "未选择门店",
 "2opnVU": "执行期间",
 "2qrsN7": "请选择门店地址",
 "2r/XUW": "移除所有本标签套用的排程模版",
 "32AbcK": "选择公司",
 "3DMdxJ": "编辑 DeviceCenter 页签",
 "3HzQUc": "导出JSON",
 "3QXG/d": "Ora版本",
 "3XHWMy": "星期四",
 "3aYG4L": "移除设备目前所套用的报警模板，不再监控与发送报警",
 "3h+3Xm": "未开业",
 "3jyOjJ": "是否将选择的设备修改为\"已注册\"",
 "3qF993": "您不能转移不在当前公司的设备。",
 "4/e9qs": "请填写名称",
 "4ImW13": "例：门店管理",
 "4R5GEq": "首页",
 "4Xdib8": "时间段不能为空",
 "4c3uw8": "移出门店",
 "4vWL+W": "导入设备",
 "4wi+/p": "范本",
 "5+oaTO": "image最后更新状态",
 "52LsQF": "例：账号中心",
 "5BTra1": "例：Platform",
 "5Cm9U3": "消息通知",
 "5Hy0Qx": "不可转移到同一门店",
 "5KtG4i": "搜索企业",
 "5WKL9+": "选择门店状态",
 "5jpkHg": "在线状态",
 "5p8cBO": "账号管理",
 "5ytYaf": "新增排程模板",
 "6+iYA0": "序号",
 "60Ixlm": "报警模板名称",
 "61gplm": "文本上传",
 "6eB+xj": "请选择指定用户",
 "6pDRb2": "请输入有效的密码",
 "6sZvzw": "替换设备中心关键字",
 "7bKyxU": "上传的图档会储存在nubis drive中的档案浏览，档案损坏或删除会导致图片载入失败",
 "7ip592": "1. 命名规则名称",
 "7pY6K/": "条款内容",
 "7q8OJE": "编辑 Platform",
 "88CuCZ": "3. 为注册在此门店的设备建立命名方式（自动填充设备名称）",
 "8PESa6": "禁用",
 "8TfVSD": "编辑 Platform 页签",
 "8huAxo": "新增规则",
 "8u3CYe": "命名规则名称",
 "8usMqO": "删除公告",
 "8zN+hZ": "执行应用",
 "9/8z30": "允许用户轻松自定义网站标题、图标和文本，以获得个性化的网络体验",
 "9/Vb7e": "上传设备",
 "919TK9": "支持格式：xls、xlsx",
 "9C+wuW": "例：设备管理",
 "9Kfib+": "未知错误",
 "9UZxwP": "请输入验证码",
 "9UefLp": "标签",
 "9cYMNA": "公司信息",
 "9g6s9o": "请填写门店编码",
 "9iKk2b": "起始号码",
 "9ljNkr": "重新发送",
 "9r00YD": "公告管理",
 "9vpYSL": "删除公司",
 "9w+ho+": "账号",
 "9yRpjk": "星期六",
 "A/eXwT": "移除所有本标签套用的报警模版",
 "A5kf1W": "全部公司列表",
 "ANeFu6": "验证密码",
 "Abqe2U": "门店地址",
 "Axagls": "请选择结束时间",
 "AyWMlZ": "添加排程任务",
 "B57Wbu": "未选择设备",
 "BBpRbn": "移除所有本门店套用的报警模版",
 "BC74I9": "提示信息",
 "BQDKvZ": "例：Agent",
 "BQcLxf": "下移",
 "BYbqwY": "将文件拖到此处 或点击上传",
 "BwXapw": "分类名称请控制在500字符内",
 "C6cGK1": "排程模板名称不能为空",
 "CLqPBU": "编辑",
 "CNkomH": "编辑条款",
 "CPTAAj": "自然数递增",
 "CoaQps": "条款管理",
 "D1cAYC": "例：设备中心",
 "D5HOUz": "选择状态",
 "DADacD": "移除所有本门店套用的排程模版",
 "DFyP1k": "闭店",
 "DqB8kg": "移除设备",
 "DxGUhN": "选择全部设备",
 "E1GPl7": "拥有者",
 "EGvInA": "设备报警列表",
 "EM8lAi": "按公司的设备可更新时间段(本地时间)",
 "EO+Nlk": "檔案上傳中，請勿關閉對話框。",
 "EO9pTF": "例：Cloud",
 "EWMpn/": "删除角色",
 "EoXhnk": "设备中心",
 "EwM8Kj": "确定要移出吗？",
 "Ey9rBq": "确定要删除吗？",
 "F2LJDJ": "确定要移除吗？",
 "F3ndvv": "删除失败",
 "FBH89G": "修改版本",
 "FEb7U2": "确认",
 "FKBH20": "例：Nubis 空间",
 "FNIJXx": "请选择滚动播放",
 "FQM81K": "是否将选择的门店状态改为",
 "FQQECq": "必填",
 "FQjcoc": "License 自动化规则",
 "FaJ/jI": "没有选择要导入的文件",
 "FbCeo1": "触发值",
 "FbsCUK": "手机",
 "Fr1I/b": "贴标签",
 "Ft60hS": "Nubis设备",
 "G+eQYn": "例：门店和账户管理",
 "G2LkOf": "公告管理上传",
 "G4XFn6": "硬体型号",
 "G4qgGm": "所有用户",
 "G5gg2V": "公告标题为必填",
 "G6i1QR": "选择地址",
 "G9APSK": "编辑命名规则",
 "Gk0Mt5": "是否确认重置（{name}）该报警设备？重置后报警规则将继续执行监控。",
 "GnzEo7": "image最后更新时间",
 "GujK99": "若后续报警模板的内容有更新，也会同步给套用的设备",
 "Gwj7xc": "恢复默认",
 "H5s58g": "24小时",
 "HHA/d7": "条款列表",
 "HN1dNJ": "所有账号",
 "HOHQFs": "命名规则名称不能为空",
 "HRXYJB": "全部公司",
 "HdxQ2/": "门店关联的配置文件与命名规则",
 "Hv/pfB": "星期二",
 "I37xbU": "请填写",
 "I9uxGU": "例：全球服务，创造您的想象力，提供智能体验",
 "ITbo35": "门店名称不能为空!",
 "IqkgWZ": "关键字",
 "Iwt/8W": "注解",
 "J0D5h+": "开始时间",
 "J3BW/8": "请输入您email收到的验证码",
 "J9jPRL": "复制成功",
 "JJl2M9": "导出",
 "JLMIof": "上传Android设备",
 "JRhVym": "营业时间不能为空",
 "JeJAmT": "重命名",
 "JeSd9K": "其他",
 "Jh62y5": "所有设备",
 "Jp7u8z": "台",
 "K1Xqdl": "例：权限管理",
 "KJHvMA": "门店管理",
 "KlWMzW": "已激活",
 "Km733q": "请选择开始时间",
 "Kwqd8h": "联系人",
 "L24ioQ": "标题",
 "L80hmc": "公告标题不得超过30字符",
 "LNGTru": "设备排程失败列表",
 "LTVlAP": "升级中心上传",
 "LWSLHa": "温馨提示",
 "Lfia0v": "设置排程",
 "LuP+H0": "描述",
 "LwhdsE": "切换多选",
 "M404r0": "二",
 "MZ5Ei7": "时间段和第{num}个时间段有重叠",
 "MmsEyp": "注册",
 "MnTdIi": "触发次数",
 "N52KMq": "详细地址",
 "NGs9sO": "返回",
 "NM/lRq": "取消上传",
 "NjB2tN": "请选择营业状态!",
 "OMcnk6": "Manufactuer",
 "OSqnZu": "是否将选择的设备版本改为",
 "OY+bYK": "确认，以后不再显示",
 "OZGX3+": "公告列表",
 "OaZpDP": "UUID",
 "OcijhH": "主板序列号",
 "OsMncl": "未开启",
 "P/eul9": "否",
 "PVmkgT": "请填写简称",
 "PaMvre": "报警规则列表",
 "PnYplH": "设备",
 "PrIueu": "24h营业",
 "Py/5UG": "操作的节点已不存在，请重新操作",
 "Q+0CDu": "新增命名规则",
 "Q1/SUP": "例：维护系统公共通知",
 "Q2/NzC": "已选择{num}台设备",
 "QAN35o": "例：管理设备、监控、远程操控设备等",
 "QH21BX": "批量注册设备",
 "QHc9Qg": "公告内容",
 "QHhMxE": "选择角色",
 "QK/hAI": "查看权限",
 "QLYuf8": "所有公司",
 "QV3pnn": "状态",
 "QpOtgZ": "门店名称",
 "Qpcx6F": "公告内容为必填",
 "Qpi3DY": "日",
 "QsAe0/": "保存失败",
 "QwHI8Q": "查询结果：",
 "R2D5Dv": "创建时间",
 "R8nCNR": "设备管理上传",
 "RCjVsb": "设备ID",
 "RNaGVr": "任务失败列表",
 "RQyKsa": "平台公告",
 "RWBRyt": "设备分布地图建设中",
 "RndUeh": "预计执行时间",
 "RyXQqJ": "上传时间",
 "S1QSWC": "汇入子门店",
 "S57QRB": "Filter by",
 "SGDlQ6": "共{total}条",
 "SbZhau": "开机任务需要指定一个开机设备",
 "SkK50H": "请添加排程任务",
 "SwMBFl": "套用排程模板",
 "T3CtvK": "分类名称不能为空",
 "TDSTTj": "选择排程模板",
 "TDuPUp": "已触发",
 "TLZPhr": "星期一",
 "TYAJpp": "已选择{num}个门店",
 "TlDh4N": "批量删除设备",
 "TqDOFU": "请勿频繁发送验证码！",
 "U08bUN": "设备中心上传",
 "UA7mv6": "Ora最后更新时间",
 "UBbWUL": "未选择任何模板",
 "UH1kCc": "添加",
 "UZ49sl": "负责人电话",
 "UcumBq": "报警通知",
 "Unvxiq": "切换账号",
 "UrM0bR": "认证信息",
 "UtE0dS": "操作",
 "Uu/nFu": "移除所有本设备套用的报警模版",
 "V0RiZp": "操作成功",
 "Vd3wZV": "整体",
 "Ve9Ksw": "转移门店",
 "ViVQNi": "角色",
 "VqEr9u": "套用门店数",
 "Vx4M25": "门店编码",
 "VzqtN+": "条款内容为必填",
 "W/wIZ8": "负责人",
 "WYHxWn": "三",
 "WYtW9Y": "请选择一个版本",
 "WdyIyo": "运作时长",
 "WqfGVu": "限制30字以内",
 "Wu2nnZ": "Platform 介绍",
 "WxPZOH": "执行{num}次",
 "WypzMq": "排程任务",
 "Wzv7kF": "请选择一个门店",
 "X2PYza": "设备详情",
 "X9zJwr": "批量指派设备",
 "XKj/en": "BIOS序列号",
 "XLdI1+": "Wi-Fi强度",
 "XMBOec": "移除标签",
 "XPFi6q": "条",
 "XeiAal": "删除",
 "XmRKnc": "备注",
 "YYGRyG": "请上传附件",
 "YeF1dY": "时区",
 "YpXN8m": "最后触发时间",
 "YwEzx2": "勾选需要显示的栏位",
 "ZGYHyC": "开始时间不能为空",
 "ZP1/uy": "例：管理Nubis平台角色使用权限",
 "ZQ91U9": "家",
 "ZUPzqr": "开启",
 "ZdO12B": "套用门店",
 "Zvt+2g": "仓储",
 "aBleoN": "选择报警模板",
 "aGxRt2": "内容",
 "aN+DgN": "激活时间",
 "aiBGBs": "删除成功",
 "akvGrq": "配置规则",
 "arp+TQ": "50条/页",
 "askOz5": "搜索地址",
 "ayjmy+": "例：管理您在全世界的设备与群组",
 "azDNha": "发送成功",
 "b+Dz+s": "全部门店列表",
 "b5l2vN": "保存",
 "bBz42a": "更新状态",
 "bE+h3K": "设备状态",
 "bFBjSK": "五",
 "bOKDVF": "切换单选",
 "bhXvJB": "权限管理上传",
 "biXcnk": "负责人邮箱",
 "bqbDVw": "查询",
 "bzfrYI": "公告配置",
 "cAIDk5": "支援中心",
 "cDZ00w": "查看",
 "cZ9/ZC": "是否删除[{name}]？",
 "cawvIS": "最后更新时间",
 "cgIBtg": "选择上层",
 "cr1ymH": "请选择发送时间",
 "d3b8dv": "个性化管理上传",
 "d7i/AT": "上层",
 "dEXfrL": "设备健康状态区间",
 "dGBGbt": "全部",
 "drCsUI": "公司",
 "e/6XZC": "没有收到验证码？",
 "e8OyHO": "20条/页",
 "eAgY2G": "展开子公司",
 "eCCa0L": "任务类型",
 "eP/37G": "注册时间",
 "eeCxuz": "OS类型",
 "ekxzlF": "名称",
 "er7lkB": "金额",
 "evJP5c": "命名规则",
 "f7Dpbl": "下载范本，根据范本提示完善内容",
 "fZJ9SZ": "例：为您的工作伙伴与客户管理账号",
 "fc12+X": "星期五",
 "fz2pkM": "该节点已被删除",
 "gU4eZD": "报警管理",
 "ggvI6Z": "全选",
 "gmUXEi": "设备特征值",
 "gnNjS5": "个人设备名称",
 "gpg5DN": "查看公告",
 "gplM71": "每日",
 "gyh+d1": "有线网络",
 "h/j3a5": "联系人电话",
 "h7w4pz": "暂无数据",
 "hD7/Lu": "显示",
 "hDx3/S": "邮箱",
 "hEI4G8": "新建公告",
 "hOtsIx": "新建条款",
 "hV5chR": "请选择是否弹窗",
 "hYN7oM": "隐藏",
 "hkJXyi": "配置排程任务",
 "i5MLJc": "最后更新时间：{lastUpdate}",
 "i6kDf/": "选择设备中包含{num}台Nubis Free版本，将无法进行设备命令。",
 "iKomBu": "暂无分类",
 "iN7Lps": "循环模式",
 "ich0wH": "设备SN",
 "ifGp4v": "2FA",
 "ilUpPP": "返回条款列表",
 "iyOrrD": "100条/页",
 "j+y4w+": "条款标题为必填",
 "j/YGZ0": "地图",
 "j3QWSE": "自然数递增的起始号码只能为正整数",
 "j4CmNU": "查看条款",
 "j6m8Si": "联系人邮箱",
 "jAAXdQ": "设备门店",
 "jAmQmn": "例：Deivce Center",
 "jJg298": "条款标题",
 "jNxbTC": "验证码不能为空",
 "jT6zKT": "设备数",
 "jhfb/7": "保存成功",
 "js3tZs": "排程模板名称",
 "k7dy8j": "关联配置文件",
 "k9dozc": "执行时间",
 "kG2Etz": "在线",
 "khyRcw": "请选择Excel文件",
 "kr+7Iy": "搜索门店",
 "kwx95y": "例：个性化管理",
 "l1fZNE": "不可全部取消勾选",
 "l36W55": "滚动播放",
 "lK6HPZ": "请选择一个门店状态",
 "lVgYx7": "停业",
 "lkP6UV": "更新设备",
 "lllhRf": "结束时间不能为空",
 "loTFGc": "未命名",
 "lzP/we": "ORA下载",
 "m0Qdyj": "验证失败",
 "m1h20o": "若后续排程模板的内容有更新，也会同步给套用的设备",
 "mFIXSq": "设备序列号",
 "mKKd1R": "请选择接收对象",
 "mYa6W/": "自定义文字",
 "ma6S6y": "自定义显示",
 "mn0ceu": "有重复的配置规则，请调整",
 "mpeFt+": "报警规则",
 "nGubXb": "排程模板详情",
 "nJCPaY": "用户没有绑定邮箱，无法进行验证",
 "nUSeQB": "未选择账号",
 "nzsNwZ": "设备健康状态",
 "o+O5d1": "请选择指派",
 "o5OLcm": "门店简称",
 "o5QBKU": "成功更新公司",
 "o8tJYm": "设备命令",
 "o9lryN": "星期日",
 "oFt+cN": "网络测速",
 "oW4Uka": "指派",
 "obfTaf": "门店配置",
 "ojz0Ke": "查看更多 >",
 "oru5FY": "编辑排程模板",
 "ov96O9": "个性化管理",
 "p/3Nn5": "移动网络",
 "pBPyFt": "Nubis版本",
 "pK94Zd": "汇入门店",
 "pV2t/S": "基本信息",
 "pXEyon": "设备类型",
 "peNVzr": "每{num}周",
 "peUIwk": "创建公告",
 "pfGGi0": "移除设备目前所套用的排程模板，不再执行",
 "pielKO": "开机设备",
 "q6qKtH": "查询条件：",
 "q9PHLT": "暂无公告",
 "q9YGIf": "营业",
 "qDba8m": "离线设备状态",
 "qUKj7E": "复制",
 "qUiH5y": "配置规则不能为空",
 "qqwM/t": "配置文件",
 "qyh9hz": "营业时间",
 "r0/TUu": "确定",
 "r2dEd/": "重置",
 "rAKRwm": "选择设备版本",
 "rDRAr0": "作业系统版本",
 "rM4ciX": "例：公告管理",
 "s1l1Jq": "门店和账户管理",
 "s7NSze": "确认操作前请先请输入您的账户密码",
 "s9U9qn": "设置报警",
 "sGYTej": "休息",
 "sOIerB": "未激活",
 "sVsXUO": "星期三",
 "sZSyGZ": "启用",
 "srEpKw": "正在上传",
 "srpWCM": "勾选需要显示的栏位，可拖动进行排序",
 "t4lrWD": "条款标题不得超过30字符",
 "t5gffJ": "设备资讯",
 "tugHWJ": "返回公告列表",
 "u3dVQz": "每周",
 "uDYj3x": "网址中心",
 "uRrPru": "门店管理上传",
 "ubuOXs": "已注册",
 "ujBeLh": "维护系统公共通知",
 "uoZwj+": "创建人",
 "uuRzdk": "归属门店",
 "v04auv": "结束时间",
 "vD5wnY": "勾选要归属的门店，代表拥有该门店的权限",
 "vD7UHb": "弹窗",
 "vDCwZ9": "上传文件",
 "vdUVb9": "例：升级中心",
 "vr5TVT": "请输入",
 "wLyMu9": "根据范本提示完善内容",
 "wOHHSJ": "上移",
 "wQAiLI": "重置提醒",
 "wYygRu": "发送人",
 "wrU/Kc": "每{num}天",
 "wzIKok": "继承上级公司的个性化管理配置",
 "x34QXR": "结束时间不可以早于开始时间",
 "x79O39": "是否确定删除？",
 "xI0mPJ": "已开启",
 "xISm1t": "激活",
 "xUjLTE": "搜索",
 "xXdMar": "指定用户",
 "xrKftB": "图标上传",
 "xuf2rG": "所有门店",
 "xx40g7": "公告标题",
 "xxETOY": "公司数据权限配置",
 "y+WxsP": "编辑公告",
 "yGWx2z": "参数错误",
 "yKFvYY": "同时发送邮件",
 "yOMNOj": "是",
 "yReEcE": "选择标签",
 "yXsHgv": "10条/页",
 "yb3AuG": "离线",
 "ybGQQ3": "无相关结果",
 "yc6ZUL": "Ora最后更新状态",
 "ydktLD": "分隔符",
 "yeCGlM": "六",
 "yfhtRM": "附件",
 "ygAHaf": "发送时间",
 "yy7EDI": "上传",
 "z7A1Fc": "创建条款",
 "zftpop": "选择用户",
 "znuEgQ": "添加营业时间段",
 "zok1hp": "C槽",
 "zvaxmN": "排程管理",
 "zyMKgy": "选择门店"
}